import {
  FiMonitor, FiRadio, FiVideo, FiWifi, FiGlobe, FiUsers, FiFileText, FiHome, FiCast, FiMic,
  FiCamera, FiFilm, FiHeadphones, FiSpeaker, FiTv, FiMusic, FiAirplay, FiSmartphone,
  FiTablet, FiPrinter, FiCpu, FiServer, FiDatabase, FiHardDrive, FiTerminal, FiCode,
  FiLayout, FiGrid, FiBox, FiPackage, FiShoppingCart, FiShoppingBag, FiCreditCard, FiDollarSign,
  FiTrendingUp, FiBarChart2, FiPieChart, FiActivity, FiTarget, FiAward, FiStar,
  FiHeart, FiThumbsUp, FiMessageSquare, FiMessageCircle, FiMail, FiSend, FiPhoneCall, FiPhone,
  FiMapPin, FiMap, FiCompass, FiNavigation, FiTruck, FiAnchor,
  FiCalendar, FiClock, FiWatch, FiSunrise, FiSun, FiMoon, FiCloud, FiCloudRain,
  FiEdit2, FiEdit3, FiPenTool, FiScissors, FiTool, FiSettings, FiSliders,
  FiZap, FiBattery, FiBookOpen, FiBook, FiBookmark, FiClipboard, FiArchive,
  FiFolder, FiFile, FiImage, FiFeather, FiFlag,
  FiGift, FiKey, FiLock, FiUnlock, FiShield, FiEye, FiEyeOff,
  FiUser, FiUserPlus, FiUserCheck, FiBriefcase, FiCoffee, FiLifeBuoy,
  FiSearch, FiZoomIn, FiMaximize, FiMinimize, FiMove, FiRefreshCw,
  FiDownload, FiUpload, FiShare2, FiLink, FiExternalLink, FiRss,
  FiHash, FiAtSign, FiPercent, FiType, FiBold, FiItalic,
  FiAlignLeft, FiAlignCenter, FiList, FiLayers, FiSidebar,
  FiChrome, FiGithub, FiFigma, FiTwitter, FiInstagram, FiFacebook, FiLinkedin, FiYoutube,
  FiPlay, FiPause, FiSkipForward, FiVolume2, FiMicOff,
  FiCheckCircle, FiXCircle, FiAlertCircle, FiInfo, FiHelpCircle,
  FiPlus, FiMinus, FiX, FiCheck,
} from 'react-icons/fi';

// Full icon registry: key -> component
export const ICON_MAP = {
  FiMonitor, FiRadio, FiVideo, FiWifi, FiGlobe, FiUsers, FiFileText, FiHome, FiCast, FiMic,
  FiCamera, FiFilm, FiHeadphones, FiSpeaker, FiTv, FiMusic, FiAirplay, FiSmartphone,
  FiTablet, FiPrinter, FiCpu, FiServer, FiDatabase, FiHardDrive, FiTerminal, FiCode,
  FiLayout, FiGrid, FiBox, FiPackage, FiShoppingCart, FiShoppingBag, FiCreditCard, FiDollarSign,
  FiTrendingUp, FiBarChart2, FiPieChart, FiActivity, FiTarget, FiAward, FiStar,
  FiHeart, FiThumbsUp, FiMessageSquare, FiMessageCircle, FiMail, FiSend, FiPhoneCall, FiPhone,
  FiMapPin, FiMap, FiCompass, FiNavigation, FiTruck, FiAnchor,
  FiCalendar, FiClock, FiWatch, FiSunrise, FiSun, FiMoon, FiCloud, FiCloudRain,
  FiEdit2, FiEdit3, FiPenTool, FiScissors, FiTool, FiSettings, FiSliders,
  FiZap, FiBattery, FiBookOpen, FiBook, FiBookmark, FiClipboard, FiArchive,
  FiFolder, FiFile, FiImage, FiFeather, FiFlag,
  FiGift, FiKey, FiLock, FiUnlock, FiShield, FiEye, FiEyeOff,
  FiUser, FiUserPlus, FiUserCheck, FiBriefcase, FiCoffee, FiLifeBuoy,
  FiSearch, FiZoomIn, FiMaximize, FiMinimize, FiMove, FiRefreshCw,
  FiDownload, FiUpload, FiShare2, FiLink, FiExternalLink, FiRss,
  FiHash, FiAtSign, FiPercent, FiType, FiBold, FiItalic,
  FiAlignLeft, FiAlignCenter, FiList, FiLayers, FiSidebar,
  FiChrome, FiGithub, FiFigma, FiTwitter, FiInstagram, FiFacebook, FiLinkedin, FiYoutube,
  FiPlay, FiPause, FiSkipForward, FiVolume2, FiMicOff,
  FiCheckCircle, FiXCircle, FiAlertCircle, FiInfo, FiHelpCircle,
  FiPlus, FiMinus, FiX, FiCheck,
};

// Get icon component by key string
export function getIconByKey(key) {
  if (!key) return null;
  return ICON_MAP[key] || null;
}

// Name-based fallback for work centres without an icon field set
export function getWorkCentreIconByName(name) {
  if (!name) return null;
  const n = name.toLowerCase();
  if (n.startsWith('media buying')) return 'FiCast';
  if (n.startsWith('tv advertising')) return 'FiMonitor';
  if (n.startsWith('radio')) return 'FiRadio';
  if (n.startsWith('studio production')) return 'FiMic';
  if (n.startsWith('video production')) return 'FiVideo';
  if (n.startsWith('live streaming')) return 'FiWifi';
  if (n.startsWith('social')) return 'FiUsers';
  if (n.startsWith('website') || n.startsWith('digital')) return 'FiGlobe';
  if (n.startsWith('consultancy')) return 'FiFileText';
  if (n.includes('hire') || n.includes('studio hire')) return 'FiHome';
  return null;
}
